import React, { useState } from 'react';
import { Container, Box, CssBaseline, Typography, Stack, Button, TextField, Menu, MenuItem, styled } from '@mui/material';
import backgroundImage from '../static/ppc-background.jpg'
import logoImage from '../static/ppc-logo-png.png'
// import logoImage from '../static/ppc-logo.svg'

import axios from 'axios'
import toast, { Toaster } from 'react-hot-toast';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { BsGoogle, BsApple, BsMicrosoft } from "react-icons/bs";
import { handleGenerateCalendarLink } from '../util/addToCalendar';
import moment from "moment/moment";


const MenuItemComponent = styled(MenuItem)(({ theme }) => ({
    display: 'flex', justifyContent: 'center', alignContent: 'center', gap: '0.4rem', alignItems:'center'
}))
export default function HomePage() {
    var Startdate = moment("2024-01-23T12:00:00");
    var EndDate = moment("2024-01-23T14:00:00");

    var formattedStartDate = Startdate.format('MMMM D, YYYY h:mm A');
    var formattedEndDate = EndDate.format('MMMM D, YYYY h:mm A');



    const [showButtons, setShowButtons] = useState(true);
    const [showForm, setShowForm] = useState(false)
    const [formData, setFormData] = useState({ name: '', email: '', company: '' });

    const [submitted, setSubmitted] = useState(false)
    const [submittedVirtual, setSubmittedVirtual] = useState(false)

    const [attending, setAttending] = useState('inperson')

    const [attendingVirutal, setAttendingVirtual] = useState(false)

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClickCalendar = (event) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEl(null);
    };

    
    const handleFormSubmit = async(event) => {
        event.preventDefault();
        // Add your form submission logic here
        console.log('Form submitted with data:', formData);

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/registrant/add/inPersonRegistrant/?token=${process.env.REACT_APP_API_BASE_TOKEN}`, { attending:attending,eventID:"65807125e6ef8495cc737cf1",...formData});
                  console.log('Response from server:', response.data);
            if(response.data.success) {
                setShowForm(false)
                attending === 'inperson' ?  setSubmitted(true) : setSubmittedVirtual(true)

            }


            if(!response.data.success) {
                // setShowForm(false)
                // setSubmitted(true)
                toast.error("User already exist")

            }

          } catch (error) {
            // Handle errors
            toast.error("Something went wrong")
            console.error('Error submitting form:', error);
          }

      };
    
      const handleInputChange = async(event) => {

        const { name, value } = event.target;
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
      };


      const handleOnBack = ()=>{
        setShowButtons(true)  
        setShowForm(false)
      }


    const handleInperson = () => {
        setAttending('inperson')
        setShowButtons(false);
        setShowForm(true)
      };

        const handleOnline =()=>{
            setAttending('virtual')
            setShowButtons(false);
            setShowForm(true)
        }
        const HandleUnabletoAttend =()=>{
            setAttending(false)
            setShowForm(true)
                // setUnableToAttend(true)
                setShowButtons(false)
        }

    return (
        <Box
            //   component="main"
            sx={{
                marginLeft: 'auto',
                marginRight: 'auto',
                width: '100%',
                height: '100vh',
                backgroundImage: `url(${backgroundImage})`,
                backgroundSize: 'cover',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Toaster />
            <CssBaseline />
            <Box
                sx={{
                    backgroundColor: 'rgba(255, 255, 255, 0.87)', // Adjust the opacity as needed
                    // background:'white',
                    borderRadius: '8px',
                    //   p: 4,
                    maxWidth: '500px',
                    width: '80%',
                    height: 'auto',
                    maxHeight:'90%',
                    textAlign: 'center',
                }}
            >
                <Box sx={{ background: '', display: 'flex', justifyContent: 'center', alignSelf: 'center', alignItems: 'center', p: 2 }}>
                    <img src={logoImage} alt="Logo" style={{ maxWidth: '100%', height: '100px' }} />

                </Box>

                <Typography sx={{ fontSize: '1.1rem' }}>
                    Capital Markets Event
                </Typography>

                <Typography sx={{ fontSize: '1.1rem' }}>
                    London, 23 January 2024
                </Typography>


             


                <Stack sx={{ p: 2 }}>
                    {
                        showButtons &&  <>
 <Typography
      sx={{
        fontSize: '1.5rem',
        fontWeight: '200%',
        '@media (max-width:600px)': {
          fontSize: '1.2rem', // Adjust the font size for smaller screens
        },
      }}
    >                    Are you able to attend?
                </Typography>
                        <Button onClick={handleInperson} sx={{
                             background: '#00A3E0', color: 'white', p: 2, m: 2, borderRadius: '15px', '&:hover': {
                                background: '#007bb5', cursor: 'pointer'
                            }
                        }}>
                            In Person participation
                        </Button>
    
    
                        <Button onClick={handleOnline}  sx={{
                             background: '#00A3E0', color: 'white', p: 2, m: 2, borderRadius: '15px', '&:hover': {
                                background: '#007bb5',
                            }
                        }}>               Online participation
                        </Button>
    
    
                        {/* <Button onClick={HandleUnabletoAttend}  sx={{
                            fontSize: '1rem', background: '#00A3E0', color: 'white', p: 2, m: 2, borderRadius: '15px', '&:hover': {
                                background: '#007bb5',
                            }
                        }}>               Unable to attend
                        </Button> */}
                            </>
                    }


                    {
                        showForm && 
                        <form onSubmit={handleFormSubmit}>
          <TextField
            label="Name"
            variant="outlined"
            fullWidth
            margin="normal"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            required
          />
          <TextField
            label="Email"
            variant="outlined"
            fullWidth
            margin="normal"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleInputChange}
            required
          />
          <TextField
            label="Company"
            variant="outlined"
            fullWidth
            margin="normal"
            name="company"
            value={formData.company}
            onChange={handleInputChange}
            required
          />
          <Box sx={{display:'flex', justifyContent:'center'}}>
          <Button onClick={handleOnBack } sx={{ fontSize: '1rem', background: '#00A3E0', color: 'white', p: 1, m: 2, '&:hover': { background: '#007bb5' } }}>
            Back
          </Button>

          <Button type="submit" sx={{ fontSize: '1rem', background: '#00A3E0', color: 'white', p: 1, m: 2, '&:hover': { background: '#007bb5' } }}>
            Submit
          </Button>

          </Box>
        </form>
                    }



                    {
                        submitted && 
                        <>
                        <Typography sx={{ fontSize: '1.1rem' }}>
                        Thank you for confirming your interest in attending the event in person.  You will soon receive an email from PPC’s IR team regarding your interest.                    </Typography>
                        
                    {/* <Typography sx={{ fontSize: '1.1rem' }}>
                       We look forward to seeing you there.
                    </Typography> */}

                    {/* <Typography sx={{ fontSize: '1.1rem' }}>
                       The Investor Relations team at PPC.
                    </Typography> */}
                        </>

                    }


{
                        submittedVirtual &&  
                        <>
                        
                        <Typography sx={{ fontSize: '1.1rem' }}>
                        Thank you for confirming your interest in attending the event via webcast.  You will soon receive an email from PPC’s IR team providing the link to join the event.                    </Typography>
                        
                    {/* <Typography sx={{ fontSize: '1.1rem' }}>
                       If you change your mind, please email us at ir@dei.gr
                    </Typography> */}

           

                        </>

                    }


{/*                     
                    {
                        showButtons ? 
                        <>
                        
                    <Button onClick={handleInperson} sx={{
                        fontSize: '1rem', background: '#00A3E0', color: 'white', p: 2, m: 2, borderRadius: '15px', '&:hover': {
                            background: '#007bb5', cursor: 'pointer'
                        }
                    }}>
                        In Person
                    </Button>


                    <Button onClick={handleOnline}  sx={{
                        fontSize: '1rem', background: '#00A3E0', color: 'white', p: 2, m: 2, borderRadius: '15px', '&:hover': {
                            background: '#007bb5',
                        }
                    }}>               Online
                    </Button>


                    <Button onClick={HandleUnabletoAttend}  sx={{
                        fontSize: '1rem', background: '#00A3E0', color: 'white', p: 2, m: 2, borderRadius: '15px', '&:hover': {
                            background: '#007bb5',
                        }
                    }}>               Unable to attend
                    </Button>
                        </>  :

                    
                      
  showForm ?
      <form onSubmit={handleFormSubmit}>
          <TextField
            label="Name"
            variant="outlined"
            fullWidth
            margin="normal"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            required
          />
          <TextField
            label="Email"
            variant="outlined"
            fullWidth
            margin="normal"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleInputChange}
            required
          />
          <TextField
            label="Company"
            variant="outlined"
            fullWidth
            margin="normal"
            name="company"
            value={formData.company}
            onChange={handleInputChange}
            required
          />
          <Box sx={{display:'flex', justifyContent:'center'}}>
          <Button onClick={()=> setShowButtons(true) } sx={{ fontSize: '1rem', background: '#00A3E0', color: 'white', p: 2, m: 2, borderRadius: '15px', '&:hover': { background: '#007bb5' } }}>
            Back
          </Button>

          <Button type="submit" sx={{ fontSize: '1rem', background: '#00A3E0', color: 'white', p: 2, m: 2, borderRadius: '15px', '&:hover': { background: '#007bb5' } }}>
            Submit
          </Button>

          </Box>
        </form> : <></>




                    

                    } */}








                </Stack>

            </Box>
        </Box>
    )
}
